import Quill from "quill"

const QuillVideo = Quill.import("formats/video")
const BlockEmbed = Quill.import("blots/block/embed")

const VIDEO_ATTRIBUTES = ["height", "width"]

// provides a custom div wrapper around the default Video blot
class Video extends BlockEmbed {
  static create(value) {
    const iframeNode = QuillVideo.create(value)

    const node = super.create()
    node.appendChild(iframeNode)
    // return node

    const parent = super.create()
    parent.appendChild(node)
    parent.setAttribute("class", "ql-video-container")
    return parent
  }

  static formats(domNode) {
    const iframe = domNode.getElementsByTagName("iframe")[0]
    return VIDEO_ATTRIBUTES.reduce(function(formats, attribute) {
      if (iframe.hasAttribute(attribute)) {
        formats[attribute] = iframe.getAttribute(attribute)
      }
      return formats
    }, {})
  }

  static value(domNode) {
    return domNode.getElementsByTagName("iframe")[0].getAttribute("src")
  }

  format(name, value) {
    if (VIDEO_ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value)
      } else {
        this.domNode.removeAttribute(name)
      }
    } else {
      super.format(name, value)
    }
  }
}

Video.blotName = "video"
Video.className = "ql-video-wrapper"
Video.tagName = "DIV"

Quill.register(Video, true)
